import ExternalLink, { ExternalLinkDto } from "../../state/integration/ExternalLink"
import SchedulingPage, { SchedulingPageDto } from "../../state/scheduling-page/SchedulingPage"

export const extractClientIdAndSlug = (url: string): { clientId: string; slug: string } | null => {
    const regex = /\/([^/]+)\/([^/]+)$/
    const match = url.match(regex)
  
    if (match) {
        const clientId = match[1]
        const slug = match[2]
        return { clientId, slug }
    }
  
    return null
}

export const getSchedulingPageIntegrationKey = (schedulingPage: SchedulingPageDto) => {
    try {
        const schedulingPg = new SchedulingPage(schedulingPage as SchedulingPageDto)
        
        const externalLinks = schedulingPg.getExternalLinks()
        if (!externalLinks || externalLinks.length === 0) {
            throw new Error("No external links found")
        }
        
        const unknownItem = externalLinks[0] as unknown
        const externalLink = new ExternalLink(unknownItem as ExternalLinkDto)
  
        const integrationKey = externalLink.getIntegrationKey()
        if (!integrationKey) {
            throw new Error("No integration key found in schedule page")
        }
  
        return integrationKey
    } catch (error) {
        console.error("Error loading scheduling page: ", error)
        return null
    }
}


// WEBPACK FOOTER //
// ./src/utils/scheduling/utils.ts